/*global _ */
import {fv} from '../../../../../lib/utils'
import {optionsHydrator} from '../../../../../lib/form/input'

import props from './../../../../../props/inputs'
import optionsProps from './../../../../../props/inputs-options'

import InputMixin from '../../../../../mixins/form/input'
import DesignerMixin from './../designer'
const mixins = [InputMixin, DesignerMixin]

export const OPTIONS_PROP = 'advancedSettings'

export default {
  mixins,
  props: {
    ...props,
    ...optionsProps,
    label: {
      type: String,
      default: null
    },
    inputClass: {
      type: String,
      default: 'custom-select'
    },
    inputErrorClass: {
      type: String,
      default: 'is-invalid form-control-error'
    },
    component: {
      type: String
    },
    componentAttrs: {
    },
    isWrapped: {
      type: [String, Number, Boolean],
      default: false
    },
    wrapperAttrs: {
    },
  },
  data() {
    return {
      innerOptions: this.options,
      optionsPropName: OPTIONS_PROP,
    }
  },
  computed: {
    optionsList() {
      const source = this.innerOptions
      const sourceIsArray = _.isArray(source)
      const useArrayOptions = this.useArrayOptions

      const options = []
      _.forOwn(source, (name, value) => {
        if (_.isObject(name)) {
          options.push(name)
        } else {
          if (sourceIsArray && !useArrayOptions) {
            options.push({value: name, name})
          } else {
            options.push({value, name})
          }
        }
      })
      return options
    },
    hasBlankOption() {
      return !_.isNil(this.blankOption)
    },
    inputComponent() {
      return this.component
    },
    hasInputComponent() {
      return this.component && !this.hasInputPlugin
    },
    hasInputPlugin() {
      return this.component && _.startsWith(this.component, 'plugin-')
    },
    inputComponentClasses() {
      const classNames = _.get(this.wrapperAttrs, 'class')
      return [classNames]
    },
    hasInputWrapper() {
      return this.isWrapped
    },
    inputWrapperClasses() {
      const classNames = _.get(this.wrapperAttrs, 'class')
      return [classNames]
    },
    slotAttrs() {
      return {
        model: this.model,
        options: this.optionsList,
        blankOption: this.blankOption,
        onInput: this.onInput,
        inputAttrs: this.inputAttrs,
        allAttrs: this.allAttrs,
        validationAttrs: this.validationAttrs,
        isDirty: this.isDirtyState,
        ...(this.hasInputWrapper ? (this.wrapperAttrs || {}): {}),
        ...(this.hasInputComponent ? (this.componentAttrs || {}): {})
      }
    }
  },
  watch: {
    options: {
      handler(newValue) {
        this.innerOptions = newValue
      },
      deep: true
    }
  },
  methods: {
    getOptionValue(option, index, options) {
      const {value, id, name, label, title, text} = option || {}
      return fv(value, id, name, label, title, text)
    },
    getOptionAttrs(option, index, options) {
      return option.attrs || {}
    },
    getOptionLabel(option, index, options) {
      const {value, id, name, label, title, text} = option || {}
      return fv(name, label, title, text, value, id)
    },
    getLabelExtraClasses() {
      return [`re-input-label-select`]
    },
    onInput(event) {
      this.isDirtyState = true
      this.model = event.target.value
    },
    hydrator: optionsHydrator,
  }
}
